import React, { useContext, useEffect, useState } from "react";
import Drawer from "@material-ui/core/Drawer";

import { callApi, isEmpty, scheduleState } from "bodycodi/cmap/app/js/common";
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import { StateContext as HomeStateContext } from "bodycodi/cmap/app/components/cmap2010/home";
import PickerHeader from "bodycodi/cmap/app/components/common/pickerHeader";
import Pass from "bodycodi/cmap/app/components/common/pass";
import empty from "bodycodi/cmap/app/img/member-profile-empty.png";
import smile from "bodycodi/cmap/app/img/smile.png";
import frown from "bodycodi/cmap/app/img/frown.png";
import cancle from "bodycodi/cmap/app/img/cancle.png";
import icon_to_right_small from "bodycodi/cmap/app/svg/icon_to_right_small.svg";
import icon_info_gray from "bodycodi/cmap/app/svg/icon_info_gray.svg";
import icon_right_arrow from "bodycodi/cmap/app/svg/icon_right_arrow.svg";

type AttendanceConfirmProp = {
  memberList: any;
  PartnerClassScheduleVO: any;
  setResultMemberList: Function;
  update: Function;
};

type ScheduleClassResultProp = {
  ResultMemberList: Array<any>;
  memberListCnt: number;
  setClickedMembers: any;
};

type ClassAttendantCntProp = {
  PartnerClassScheduleVO: any;
  update: Function;
};

type ShceduleClassStep = {
  memberList: any;
};

const ShceduleClassStep = ({ memberList }: ShceduleClassStep) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CLASS_SCHEDULE_BTN_POP",
      open: { classScheduleBtnPop: false },
    });
  };

  const openAttandance = () => {
    if (memberList.length === 1) {
      dispatch({
        type: "POP_UP_OPEN",
        id: "CLASS_SCHEDULE_CONFIRM_ONE_POP",
        open: { classScheduleConfirmOnePop: true },
      });
    } else {
      dispatch({
        type: "POP_UP_OPEN",
        id: "CLASS_SCHEDULE_CONFIRM_POP",
        open: { classScheduleConfirmPop: true },
      });
    }
  };
  const openAbsent = () => {
    if (memberList.length === 1) {
      dispatch({
        type: "POP_UP_OPEN",
        id: "CLASS_ABSENT_CONFIRM_ONE_POP",
        open: { classAbsentConfirmOnePop: true },
      });
    } else {
      dispatch({
        type: "POP_UP_OPEN",
        id: "CLASS_ABSENT_CONFIRM_POP",
        open: { classAbsentConfirmPop: true },
      });
    }
  };
  const openCancel = () => {
    if (memberList.length === 1) {
      dispatch({
        type: "POP_UP_OPEN",
        id: "RSRV_CANCLE_CONFIRM_ONE_POP",
        open: { rsrvCancleConfirmOnePop: true },
      });
    } else {
      dispatch({
        type: "POP_UP_OPEN",
        id: "RSRV_CANCLE_CONFIRM_POP",
        open: { rsrvCancleConfirmMultiPop: true },
      });
    }
  };
  const openAttendantCntPop = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CLASS_ATTENDANT_CNT_POP",
      open: { classAttendantCntPop: true },
    });
  };

  return (
    <Drawer
      anchor="bottom"
      open={state.classScheduleBtnPop}
      onClose={handleClose}
      className="picker-pop"
    >
      <PickerHeader title="출결 처리하기" onClose={handleClose} />
      <div className="picker-body">
        <div className="schedule-attendance">
          {memberList.length === 1 ? (
            <>
              <div
                className={`schedule-attendance-btn green class ${
                  memberList[0].scheduleState === "E" && "disable"
                }`}
                onClick={memberList[0].scheduleState === "E" ? undefined : openAttandance}
              >
                <img src={smile} />
                출석처리
              </div>
              <div
                className={`schedule-attendance-btn red class ${
                  memberList[0].scheduleState === "A" && "disable"
                }`}
                onClick={memberList[0].scheduleState === "A" ? undefined : openAbsent}
              >
                <img src={frown} />
                결석처리
              </div>
              <div className="schedule-attendance-btn gray class" onClick={openCancel}>
                <img src={cancle} />
                예약취소
              </div>
            </>
          ) : (
            <>
              <div className="schedule-attendance-btn green class" onClick={openAttandance}>
                <img src={smile} />
                출석처리
              </div>
              <div className="schedule-attendance-btn red class" onClick={openAbsent}>
                <img src={frown} />
                결석처리
              </div>
              <div className="schedule-attendance-btn gray class" onClick={openCancel}>
                <img src={cancle} />
                예약취소
              </div>
            </>
          )}
        </div>
        <div className="schedule-attendant-cnt" onClick={openAttendantCntPop}>
          그룹수업 참여 회원수 직접 입력
        </div>
      </div>
    </Drawer>
  );
};

export const AttendanceConfirm = ({
  memberList,
  PartnerClassScheduleVO,
  setResultMemberList,
  update,
}: AttendanceConfirmProp) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const { state: homeState } = useContext(HomeStateContext);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CLASS_SCHEDULE_CONFIRM_POP",
      open: { classScheduleConfirmPop: false },
    });
  };

  const clickAttandance = () => {
    dispatch({ type: "LOADING_START" });
    const seqMembers = memberList.map((v: any) => v.seqMember);
    callApi(
      "/class/reservation/state",
      {
        memberList: seqMembers,
        seqPartnerClassSchedule: PartnerClassScheduleVO.seqPartnerClassSchedule,
        scheduleState: "E",
        seqPartnerCoach: PartnerClassScheduleVO.seqPartnerCoach,
      },
      "PATCH"
    )
      .then((res) => {
        if (res.msgVO) {
          if (res.msgVO.msgCd === "CMAP2030-00") {
            handleClose();
            update();
            homeState.scheduleDtlPop.update();
            setResultMemberList(res.resultMemberList);
            dispatch({
              type: "POP_UP_OPEN",
              id: "CLASS_SCHEDULE_RESULT_POP",
              open: { classScheduleResultPop: true },
            });
            dispatch({ type: "UPDATE_SCHDULE" });
          } else {
            dispatch({ type: "UPDATE", data: { toast: true, toastText: res.MsgVO.msgCtnt } });
          }
        }
      })
      .finally(() => {
        dispatch({ type: "LOADING_END" });
      });
  };

  return (
    <Drawer
      anchor="bottom"
      open={state.classScheduleConfirmPop}
      onClose={handleClose}
      className="picker-pop"
    >
      <div className="schedule-btn-pop">
        <div className="schedule-class-member-wrap">
          {memberList.map((v: any, i: number) => {
            if (i > 4) {
              return <></>;
            }
            return (
              <div className="schedule-class-member" key={v.seqMember}>
                <img src={v.imgUrl || empty} />
              </div>
            );
          })}
          {memberList.length > 5 && <div className="union">+{memberList.length - 5}</div>}
        </div>
        <div className="member-name">
          {memberList.length}명의 회원님을
          <br />
          <span>일괄 출석처리</span> 할까요?
        </div>
        <div className="member-decution-btn-wrap">
          <div className="btn cancle" onClick={handleClose}>
            취소
          </div>
          <div className="btn attandance" onClick={clickAttandance}>
            출석처리
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export const ScheduleClassResult = ({
  ResultMemberList,
  memberListCnt,
  setClickedMembers,
}: ScheduleClassResultProp) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CLASS_SCHEDULE_RESULT_POP",
      open: { classScheduleResultPop: false },
    });
    dispatch({
      type: "POP_UP_OPEN",
      id: "CLASS_SCHEDULE_BTN_POP",
      open: { classScheduleBtnPop: false },
    });
    setClickedMembers([]);
  };

  let size = 0;
  for (let i = 0; i < ResultMemberList.length; i++) {
    if (ResultMemberList[i].afterScheduleState === "E") {
      size++;
    }
  }

  const list = ResultMemberList.map((d: any, i: number) => {
    const src = isEmpty(d.imgUrl) ? empty : d.imgUrl;
    let beforeClassName = "";
    if (d.beforeScheduleState === "E") {
      beforeClassName = "state green";
    } else if (d.beforeScheduleState === "R") {
      beforeClassName = "state blue";
    } else if (d.beforeScheduleState === "C") {
      beforeClassName = "state red";
    } else if (d.beforeScheduleState === "A") {
      beforeClassName = "state red";
    } else if (d.beforeScheduleState === "W") {
      beforeClassName = "state blue";
    }

    let afterClassName = "";
    if (d.afterScheduleState === "E") {
      afterClassName = "state green bold";
    } else if (d.afterScheduleState === "R") {
      afterClassName = "state blue";
    } else if (d.afterScheduleState === "C") {
      afterClassName = "state red";
    } else if (d.afterScheduleState === "A") {
      afterClassName = "state red";
    } else if (d.afterScheduleState === "W") {
      afterClassName = "state blue";
    }

    return (
      <div
        key={i}
        className={"schedule-class-result" + (d.afterScheduleState !== "E" ? " disable" : "")}
      >
        <div className="profile-wrap">
          <img className="profile" src={src} />
          <span className="name">{d.name}</span>
        </div>
        <div className="count">
          <span className="beforeCount">
            {d.beforeUseNumber === -1 ? `무제한 ` : `${d.beforeUseNumber}회 `}
          </span>
          <span className={beforeClassName}>{scheduleState(d.beforeScheduleState)}</span>
          <img className="arrow" src={icon_to_right_small} />
          <span className="afterCount">
            {d.afterUseNumber === -1 ? `무제한 ` : `${d.afterUseNumber}회 `}
          </span>
          <span className={afterClassName}>{scheduleState(d.afterScheduleState)}</span>
        </div>
      </div>
    );
  });

  return (
    <Drawer
      anchor="bottom"
      open={state.classScheduleResultPop}
      onClose={handleClose}
      className="picker-pop"
    >
      <div className="schedule-class-result-pop">
        <div className="schedule-class-result-title">
          선택한 {memberListCnt}명중 <span>{size}명</span>의 회원님을 <br />
          <span>일괄 출석처리</span> 했어요.
        </div>
        <div className="schedule-class-result-decs">
          예약한 이용권의 잔여횟수 변경사항을 확인하세요.
        </div>
        <div className="schedule-class-result-list">{list}</div>
        <div className="schedule-class-result-btn" onClick={handleClose}>
          확인
        </div>
      </div>
    </Drawer>
  );
};

export const AbsentConfirm = ({
  memberList,
  PartnerClassScheduleVO,
  setResultMemberList,
  update,
}: AttendanceConfirmProp) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const { state: homeState } = useContext(HomeStateContext);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CLASS_ABSENT_CONFIRM_POP",
      open: { classAbsentConfirmPop: false },
    });
  };

  const handleClickAbsent = () => {
    dispatch({ type: "LOADING_START" });
    const seqMembers = memberList.map((v: any) => v.seqMember);
    callApi(
      "/class/reservation/state",
      {
        memberList: seqMembers,
        seqPartnerClassSchedule: PartnerClassScheduleVO.seqPartnerClassSchedule,
        scheduleState: "A",
        seqPartnerCoach: PartnerClassScheduleVO.seqPartnerCoach,
      },
      "PATCH"
    )
      .then((res) => {
        if (res.msgVO) {
          if (res.msgVO.msgCd === "CMAP2030-00") {
            handleClose();
            update();
            homeState.scheduleDtlPop.update();
            setResultMemberList(res.resultMemberList);
            dispatch({
              type: "POP_UP_OPEN",
              id: "CLASS_SCHEDULE_RESULT_ABSENT_POP",
              open: { classScheduleResultAbsentPop: true },
            });
            dispatch({ type: "UPDATE_SCHDULE" });
          } else {
            dispatch({ type: "UPDATE", data: { toast: true, toastText: res.MsgVO.msgCtnt } });
          }
        }
      })
      .finally(() => {
        dispatch({ type: "LOADING_END" });
      });
  };

  return (
    <Drawer
      anchor="bottom"
      open={state.classAbsentConfirmPop}
      onClose={handleClose}
      className="picker-pop"
    >
      <div className="schedule-btn-pop">
        <div className="schedule-class-member-wrap">
          {memberList.map((v: any, i: number) => {
            if (i > 4) {
              return <></>;
            }
            return (
              <div className="schedule-class-member" key={v.seqMember}>
                <img src={v.imgUrl || empty} />
              </div>
            );
          })}
          {memberList.length > 5 && <div className="union">+{memberList.length - 5}</div>}
        </div>
        <div className="member-name">
          {memberList.length}명의 회원님을
          <br />
          <span className="red">일괄 결석처리</span> 할까요?
        </div>
        <div className="member-decution-btn-wrap">
          <div className="btn cancle" onClick={handleClose}>
            취소
          </div>
          <div className="btn absent" onClick={handleClickAbsent}>
            결석처리
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export const ScheduleClassResultAbsent = ({
  ResultMemberList,
  memberListCnt,
  setClickedMembers,
}: ScheduleClassResultProp) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CLASS_SCHEDULE_RESULT_ABSENT_POP",
      open: { classScheduleResultAbsentPop: false },
    });
    dispatch({
      type: "POP_UP_OPEN",
      id: "CLASS_SCHEDULE_BTN_POP",
      open: { classScheduleBtnPop: false },
    });
    setClickedMembers([]);
  };

  let size = 0;
  for (let i = 0; i < ResultMemberList.length; i++) {
    if (ResultMemberList[i].afterScheduleState === "A") {
      size++;
    }
  }

  const list = ResultMemberList.map((d: any, i: number) => {
    const src = isEmpty(d.imgUrl) ? empty : d.imgUrl;
    let beforeClassName = "";
    if (d.beforeScheduleState === "E") {
      beforeClassName = "state green";
    } else if (d.beforeScheduleState === "R") {
      beforeClassName = "state blue";
    } else if (d.beforeScheduleState === "C") {
      beforeClassName = "state red";
    } else if (d.beforeScheduleState === "A") {
      beforeClassName = "state red";
    } else if (d.beforeScheduleState === "W") {
      beforeClassName = "state blue";
    }

    let afterClassName = "";
    if (d.afterScheduleState === "E") {
      afterClassName = "state green bold";
    } else if (d.afterScheduleState === "R") {
      afterClassName = "state blue";
    } else if (d.afterScheduleState === "C") {
      afterClassName = "state red";
    } else if (d.afterScheduleState === "A") {
      afterClassName = "state red";
    } else if (d.afterScheduleState === "W") {
      afterClassName = "state blue";
    }

    return (
      <div
        key={i}
        className={"schedule-class-result" + (d.afterScheduleState !== "A" ? " disable" : "")}
      >
        <div className="profile-wrap">
          <img className="profile" src={src} />
          <span className="name">{d.name}</span>
        </div>
        <div className="count">
          <span className="beforeCount">
            {d.beforeUseNumber === -1 ? `무제한 ` : `${d.beforeUseNumber}회 `}
          </span>
          <span className={beforeClassName}>{scheduleState(d.beforeScheduleState)}</span>
          <img className="arrow" src={icon_to_right_small} />
          <span className="afterCount">
            {d.afterUseNumber === -1 ? `무제한 ` : `${d.afterUseNumber}회 `}
          </span>
          <span className={afterClassName}>{scheduleState(d.afterScheduleState)}</span>
        </div>
      </div>
    );
  });

  return (
    <Drawer
      anchor="bottom"
      open={state.classScheduleResultAbsentPop}
      onClose={handleClose}
      className="picker-pop"
    >
      <div className="schedule-class-result-pop">
        <div className="schedule-class-result-title">
          선택한 {memberListCnt}명중 <span className="red">{size}명</span>의 회원님을 <br />
          <span className="red">일괄 결석처리</span> 했어요.
        </div>
        <div className="schedule-class-result-decs">
          예약한 이용권의 잔여횟수 변경사항을 확인하세요.
        </div>
        <div className="schedule-class-result-list">{list}</div>
        <div className="schedule-class-result-btn" onClick={handleClose}>
          확인
        </div>
      </div>
    </Drawer>
  );
};

export const ClassAttendantCnt = ({ PartnerClassScheduleVO, update }: ClassAttendantCntProp) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const { state: homeState } = useContext(HomeStateContext);
  const [textNumber, setTextNumber] = useState<number | "">(1);

  // 현재시간 이전의 그룹수업만 회원수 입력 가능
  const classDateTime = `${PartnerClassScheduleVO?.startDt?.substring(0, 11)}${
    PartnerClassScheduleVO.startTime
  }:00`;
  const isAvaiableChange =
    new Date(classDateTime).getDate() === new Date().getDate() &&
    new Date(classDateTime).getTime() < new Date().getTime();

  useEffect(() => {
    setTextNumber(PartnerClassScheduleVO.attendantCnt);
  }, [PartnerClassScheduleVO]);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CLASS_ATTENDANT_CNT_POP",
      open: { classAttendantCntPop: false },
    });
  };

  const changeAttendantCnt = () => {
    callApi(
      "/cmap2030/execClassCmpltReg",
      {
        attendantCnt: textNumber,
        seqPartner: PartnerClassScheduleVO.seqPartner,
        seqCoach: PartnerClassScheduleVO.seqPartnerCoach,
        seqPartnerClass: PartnerClassScheduleVO.seqPartnerClass,
        seqPartnerClassSchedule: PartnerClassScheduleVO.seqPartnerClassSchedule,
        startDate: `${PartnerClassScheduleVO.startDt.substring(0, 10)} ${
          PartnerClassScheduleVO.startTime
        }:00`,
        endDate: `${PartnerClassScheduleVO.endDt.substring(0, 10)} ${
          PartnerClassScheduleVO.endTime
        }:00`,
      },
      "POST"
    ).then((res) => {
      if (res.MsgVO.msgCd === "CMAP2030-00") {
        handleClose();
        update();
        homeState.scheduleDtlPop.update();
        dispatch({
          type: "UPDATE",
          data: { toast: true, toastText: "그룹수업 참여 회원수가 변경되었습니다." },
        });
      } else {
        dispatch({ type: "UPDATE", data: { toast: true, toastText: res.MsgVO.msgCtnt } });
      }
    });
  };

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value === "") {
      setTextNumber("");
      return;
    }
    setTextNumber(parseInt(e.target.value, 10));
  };

  return (
    <Drawer
      anchor="bottom"
      open={state.classAttendantCntPop}
      onClose={handleClose}
      className="picker-pop"
    >
      <div className="class-attendant-cnt-pop">
        <div className="title">그룹수업 참여 회원수 직접 입력</div>
        <div className="attendant-cnt-wrap">
          <div className="attendant-cnt-blue">
            <input
              type="number"
              pattern="[0-9]*"
              inputMode="numeric"
              value={isAvaiableChange ? textNumber : 0}
              onChange={handleChangeInput}
              autoFocus={isAvaiableChange}
              disabled={!isAvaiableChange}
            />
          </div>
          <div className="attendant-cnt-blue">명 참여</div>
          <div className="attendant-cnt-slash"></div>
          <div className="attendant-cnt-gray">
            정원 {PartnerClassScheduleVO.reservationLimitNo}명
          </div>
        </div>
        <div className="text">
          그룹수업에 참여한 총 회원수를 기록합니다.
          <br />
          출결처리에는 반영되지 않습니다.
        </div>
        <div className="member-decution-btn-wrap">
          <div className="btn cancle" onClick={handleClose}>
            취소
          </div>
          <div
            className={`btn rsrv ${
              (!isAvaiableChange ||
                textNumber === "" ||
                textNumber > PartnerClassScheduleVO.reservationLimitNo) &&
              "disable"
            }`}
            onClick={
              !isAvaiableChange ||
              textNumber === "" ||
              textNumber > PartnerClassScheduleVO.reservationLimitNo
                ? undefined
                : changeAttendantCnt
            }
          >
            완료
          </div>
        </div>
        {!isAvaiableChange && (
          <div className="info-change-disable">
            <img src={icon_info_gray} />
            <span>오늘 수업만 참여 회원수를 입력할 수 있어요.</span>
          </div>
        )}
      </div>
    </Drawer>
  );
};

interface ConfirmOne {
  d: any;
  setClickedMembers: Function;
  update: Function;
  PartnerClassScheduleVO: any;
}

export const AttendanceConfirmOne = ({
  d,
  setClickedMembers,
  update,
  PartnerClassScheduleVO,
}: ConfirmOne) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const { state: homeState } = useContext(HomeStateContext);
  const [pass, setPass] = useState<any>({});

  useEffect(() => {
    if (!state.classScheduleConfirmOnePop) {
      return;
    }
    callApi(
      "/cmap2030/viewClassAttandance",
      { seqMember: d.seqMember, seqSchedule: d.seqSchedule },
      "GET"
    ).then((res) => {
      setPass(res.PassVO);
    });
  }, [state.classScheduleConfirmOnePop]);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CLASS_SCHEDULE_CONFIRM_ONE_POP",
      open: { classScheduleConfirmOnePop: false },
    });
  };

  const src = isEmpty(d.imgUrl) ? empty : d.imgUrl;

  const clickAttandance = () => {
    dispatch({ type: "LOADING_START" });
    callApi(
      "/class/reservation/state",
      {
        memberList: [d.seqMember],
        seqPartnerClassSchedule: PartnerClassScheduleVO.seqPartnerClassSchedule,
        scheduleState: "E",
        seqPartnerCoach: PartnerClassScheduleVO.seqPartnerCoach,
      },
      "PATCH"
    )
      .then((res) => {
        if (res.msgVO) {
          if (res.msgVO.msgCd === "CMAP2030-00") {
            handleClose();
            update();
            homeState.scheduleDtlPop.update();
            dispatch({
              type: "UPDATE",
              data: {
                toast: true,
                toastText: "<span>" + d.name + "</span>님을 <span>출석처리</span>했습니다.",
              },
            });
            dispatch({ type: "UPDATE_SCHDULE" });
            dispatch({
              type: "POP_UP_OPEN",
              id: "CLASS_SCHEDULE_BTN_POP",
              open: { classScheduleBtnPop: false },
            });
            setClickedMembers([]);
          } else {
            dispatch({ type: "UPDATE", data: { toast: true, toastText: res.MsgVO.msgCtnt } });
          }
        }
      })
      .finally(() => {
        dispatch({ type: "LOADING_END" });
      });
  };

  return (
    <Drawer
      anchor="bottom"
      open={state.classScheduleConfirmOnePop}
      onClose={handleClose}
      className="picker-pop"
    >
      {state.classScheduleConfirmOnePop && (
        <div className="schedule-btn-pop">
          <img className="member" src={src} />
          <div className="member-name bottom-pass">
            {d.name}님을
            <br />
            <span>출석처리</span> 할까요?
          </div>
          {!isEmpty(pass) && <Pass d={pass} isAdd={false} isClassCheck={true} />}
          <div className="member-decution">
            {pass.numberPassYn === "N" ? (
              <>이용권의 잔여횟수가 유지됩니다.</>
            ) : d.voucherMinusYn === "Y" && d.scheduleState === "A" ? (
              <>이용권의 잔여횟수가 유지됩니다.</>
            ) : (
              <>이용권의 잔여횟수가 {d.lessonAmount}회 차감됩니다.</>
            )}
          </div>
          <div className="member-decution-cnt">
            {pass.numberPassYn === "N" && (
              <>
                {d.scheduleState === "R" && (
                  <ul>
                    <li className="count">무제한</li>
                    <li className="union blue">예약</li>
                  </ul>
                )}
                {d.scheduleState === "A" && (
                  <ul>
                    <li className="count">무제한</li>
                    <li className="union red">결석</li>
                  </ul>
                )}
                <img src={icon_right_arrow} />
                <ul>
                  <li className="count bold">무제한</li>
                  <li className="union green">출석</li>
                </ul>
              </>
            )}
            {pass.numberPassYn === "Y" && (
              <>
                {d.voucherMinusYn === "Y" && (
                  <>
                    {d.scheduleState === "R" && (
                      <>
                        <ul>
                          <li className="count">{pass.remainNumber}회</li>
                          <li className="union blue">예약</li>
                        </ul>
                        <img src={icon_right_arrow} />
                        <ul>
                          <li className="count bold">{pass.remainNumber - d.lessonAmount}회</li>
                          <li className="union green">출석</li>
                        </ul>
                      </>
                    )}
                    {d.scheduleState === "A" && (
                      <>
                        <ul>
                          <li className="count">{pass.remainNumber}회</li>
                          <li className="union red">결석</li>
                        </ul>
                        <img src={icon_right_arrow} />
                        <ul>
                          <li className="count bold">{pass.remainNumber}회</li>
                          <li className="union green">출석</li>
                        </ul>
                      </>
                    )}
                  </>
                )}
                {d.voucherMinusYn === "N" && (
                  <>
                    {d.scheduleState === "R" && (
                      <>
                        <ul>
                          <li className="count">{pass.remainNumber}회</li>
                          <li className="union blue">예약</li>
                        </ul>
                        <img src={icon_right_arrow} />
                        <ul>
                          <li className="count bold">{pass.remainNumber - d.lessonAmount}회</li>
                          <li className="union green">출석</li>
                        </ul>
                      </>
                    )}
                    {d.scheduleState === "A" && (
                      <>
                        <ul>
                          <li className="count">{pass.remainNumber}회</li>
                          <li className="union red">결석</li>
                        </ul>
                        <img src={icon_right_arrow} />
                        <ul>
                          <li className="count bold">{pass.remainNumber - d.lessonAmount}회</li>
                          <li className="union green">출석</li>
                        </ul>
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </div>
          <div className="member-decution-btn-wrap">
            <div className="btn cancle" onClick={handleClose}>
              취소
            </div>
            <div className="btn attandance" onClick={clickAttandance}>
              출석처리
            </div>
          </div>
        </div>
      )}
    </Drawer>
  );
};

export const AbsentConfirmOne = ({
  d,
  setClickedMembers,
  update,
  PartnerClassScheduleVO,
}: ConfirmOne) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const { state: homeState } = useContext(HomeStateContext);
  const [pass, setPass] = useState<any>({});

  useEffect(() => {
    if (!state.classAbsentConfirmOnePop) {
      return;
    }
    callApi(
      "/cmap2030/viewClassAttandance",
      { seqMember: d.seqMember, seqSchedule: d.seqSchedule },
      "GET"
    ).then((res) => {
      setPass(res.PassVO);
    });
  }, [state.classAbsentConfirmOnePop]);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CLASS_ABSENT_CONFIRM_ONE_POP",
      open: { classAbsentConfirmOnePop: false },
    });
  };

  const src = isEmpty(d.imgUrl) ? empty : d.imgUrl;

  const clickAbsent = () => {
    dispatch({ type: "LOADING_START" });
    callApi(
      "/class/reservation/state",
      {
        memberList: [d.seqMember],
        seqPartnerClassSchedule: PartnerClassScheduleVO.seqPartnerClassSchedule,
        scheduleState: "A",
        seqPartnerCoach: PartnerClassScheduleVO.seqPartnerCoach,
      },
      "PATCH"
    )
      .then((res) => {
        if (res.msgVO) {
          if (res.msgVO.msgCd === "CMAP2030-00") {
            handleClose();
            update();
            homeState.scheduleDtlPop.update();
            dispatch({
              type: "UPDATE",
              data: {
                toast: true,
                toastText: "<span>" + d.name + "</span>님을 <span>결석처리</span>했습니다.",
              },
            });
            dispatch({ type: "UPDATE_SCHDULE" });
            dispatch({
              type: "POP_UP_OPEN",
              id: "CLASS_SCHEDULE_BTN_POP",
              open: { classScheduleBtnPop: false },
            });
            setClickedMembers([]);
          } else {
            dispatch({ type: "UPDATE", data: { toast: true, toastText: res.MsgVO.msgCtnt } });
          }
        }
      })
      .finally(() => {
        dispatch({ type: "LOADING_END" });
      });
  };

  return (
    <Drawer
      anchor="bottom"
      open={state.classAbsentConfirmOnePop}
      onClose={handleClose}
      className="picker-pop"
    >
      {state.classAbsentConfirmOnePop && (
        <div className="schedule-btn-pop">
          <img className="member" src={src} />
          <div className="member-name bottom-pass">
            {d.name}님을
            <br />
            <span className="red">결석처리</span> 할까요?
          </div>
          {!isEmpty(pass) && <Pass d={pass} isAdd={false} isClassCheck={true} />}
          <div className="member-decution">
            {pass.numberPassYn === "N" && <>이용권의 잔여횟수가 유지됩니다.</>}
            {pass.numberPassYn === "Y" && (
              <>
                {d.voucherMinusYn === "Y" && d.scheduleState === "R" && (
                  <>이용권의 잔여횟수가 {d.lessonAmount}회 차감됩니다.</>
                )}
                {d.voucherMinusYn === "Y" && d.scheduleState === "E" && (
                  <>이용권의 잔여횟수가 유지됩니다.</>
                )}
                {d.voucherMinusYn === "N" && d.scheduleState === "R" && (
                  <>이용권의 잔여횟수가 유지됩니다.</>
                )}
                {d.voucherMinusYn === "N" && d.scheduleState === "E" && (
                  <>이용권의 잔여횟수가 {d.lessonAmount}회 복구됩니다.</>
                )}
              </>
            )}
          </div>
          <div className="member-decution-cnt">
            {pass.numberPassYn === "N" && (
              <>
                {d.scheduleState === "R" && (
                  <ul>
                    <li className="count">무제한</li>
                    <li className="union blue">예약</li>
                  </ul>
                )}
                {d.scheduleState === "E" && (
                  <ul>
                    <li className="count">무제한</li>
                    <li className="union green">출석</li>
                  </ul>
                )}
                <img src={icon_right_arrow} />
                <ul>
                  <li className="count bold">무제한</li>
                  <li className="union red">결석</li>
                </ul>
              </>
            )}
            {pass.numberPassYn === "Y" && (
              <>
                {d.voucherMinusYn === "Y" && (
                  <>
                    {d.scheduleState === "R" && (
                      <>
                        <ul>
                          <li className="count">{pass.remainNumber}회</li>
                          <li className="union blue">예약</li>
                        </ul>
                        <img src={icon_right_arrow} />
                        <ul>
                          <li className="count bold">{pass.remainNumber - d.lessonAmount}회</li>
                          <li className="union red">결석</li>
                        </ul>
                      </>
                    )}
                    {d.scheduleState === "E" && (
                      <>
                        <ul>
                          <li className="count">{pass.remainNumber}회</li>
                          <li className="union green">출석</li>
                        </ul>
                        <img src={icon_right_arrow} />
                        <ul>
                          <li className="count bold">{pass.remainNumber}회</li>
                          <li className="union red">결석</li>
                        </ul>
                      </>
                    )}
                  </>
                )}
                {d.voucherMinusYn === "N" && (
                  <>
                    {d.scheduleState === "R" && (
                      <>
                        <ul>
                          <li className="count">{pass.remainNumber}회</li>
                          <li className="union blue">예약</li>
                        </ul>
                        <img src={icon_right_arrow} />
                        <ul>
                          <li className="count bold">{pass.remainNumber}회</li>
                          <li className="union red">결석</li>
                        </ul>
                      </>
                    )}
                    {d.scheduleState === "E" && (
                      <>
                        <ul>
                          <li className="count">{pass.remainNumber}회</li>
                          <li className="union green">출석</li>
                        </ul>
                        <img src={icon_right_arrow} />
                        <ul>
                          <li className="count bold">{pass.remainNumber + d.lessonAmount}회</li>
                          <li className="union red">결석</li>
                        </ul>
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </div>
          <div className="member-decution-btn-wrap">
            <div className="btn cancle" onClick={handleClose}>
              취소
            </div>
            <div className="btn absent" onClick={clickAbsent}>
              결석처리
            </div>
          </div>
        </div>
      )}
    </Drawer>
  );
};

export const RsrvCancleConfirmOne = ({
  d,
  setClickedMembers,
  update,
  PartnerClassScheduleVO,
}: ConfirmOne) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const { state: homeState } = useContext(HomeStateContext);
  const [pass, setPass] = useState<any>({});
  const { name, seqMember, seqSchedule, imgUrl } = d || {};

  useEffect(() => {
    if (!state.rsrvCancleConfirmOnePop) {
      return;
    }
    callApi(
      "/cmap2030/viewClassAttandance",
      { seqMember: seqMember, seqSchedule: seqSchedule },
      "GET"
    ).then((res) => {
      setPass(res.PassVO);
    });
  }, [state.rsrvCancleConfirmOnePop]);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "RSRV_CANCLE_CONFIRM_ONE_POP",
      open: { rsrvCancleConfirmOnePop: false },
    });
  };

  const handleClickCancel = () => {
    dispatch({ type: "LOADING_START" });
    callApi(
      "/class/reservation/state",
      {
        memberList: [seqMember],
        seqPartnerClassSchedule: PartnerClassScheduleVO.seqPartnerClassSchedule,
        scheduleState: "C",
        seqPartnerCoach: PartnerClassScheduleVO.seqPartnerCoach,
      },
      "PATCH"
    )
      .then((res) => {
        if (res.msgVO) {
          if (res.msgVO.msgCd === "CMAP2030-00") {
            handleClose();
            update();
            homeState.scheduleDtlPop.update();
            dispatch({
              type: "UPDATE",
              data: {
                toast: true,
                toastText: "<span>" + name + "님을 예약취소 했습니다.</span>",
              },
            });
            dispatch({ type: "UPDATE_SCHDULE" });
            dispatch({
              type: "POP_UP_OPEN",
              id: "CLASS_SCHEDULE_BTN_POP",
              open: { classScheduleBtnPop: false },
            });
            setClickedMembers([]);
          } else {
            dispatch({ type: "UPDATE", data: { toast: true, toastText: res.MsgVO.msgCtnt } });
          }
        }
      })
      .finally(() => {
        dispatch({ type: "LOADING_END" });
      });
  };

  const getPassSummary = (
    numberPassYn: string,
    voucherMinusYn: string,
    scheduleState: string,
    lessonAmount: number,
    to: string
  ) => {
    if (numberPassYn === "N") {
      return {
        cnt: 1000,
      };
    }
    if (numberPassYn === "Y") {
      if (to === "C") {
        if (voucherMinusYn === "Y" && scheduleState === "R") {
          return {
            cnt: 0,
          };
        }
        if (voucherMinusYn === "Y" && scheduleState === "E") {
          return {
            cnt: lessonAmount,
          };
        }
        if (voucherMinusYn === "Y" && scheduleState === "A") {
          return {
            cnt: lessonAmount,
          };
        }
        if (voucherMinusYn === "N" && scheduleState === "R") {
          return {
            cnt: 0,
          };
        }
        if (voucherMinusYn === "N" && scheduleState === "E") {
          return {
            cnt: lessonAmount,
          };
        }
        if (voucherMinusYn === "N" && scheduleState === "A") {
          return {
            cnt: 0,
          };
        }
      }
    }
    return {
      cnt: 1000,
    };
  };

  const { cnt } = getPassSummary(
    pass.numberPassYn,
    d.voucherMinusYn,
    d.scheduleState,
    d.lessonAmount,
    "C"
  );
  return (
    <>
      <Drawer
        anchor="bottom"
        open={state.rsrvCancleConfirmOnePop}
        onClose={handleClose}
        className="picker-pop"
      >
        <div className="schedule-btn-pop">
          <div className="schedule-class-member-wrap">
            <div className="schedule-class-member big">
              <img src={isEmpty(imgUrl) ? empty : imgUrl} />
            </div>
          </div>
          <div className="member-name bottom-pass">
            {name}님을
            <br />
            <span className="gray">예약취소 </span> 할까요?
          </div>
          {!isEmpty(pass) && <Pass d={pass} isAdd={false} isClassCheck={true} />}

          <div className="member-decution">
            {cnt === 0 || cnt === 1000 ? (
              <>이용권의 잔여횟수가 유지됩니다.</>
            ) : (
              <>
                이용권의 잔여횟수가 {cnt}회 {cnt > 0 ? "복구" : "차감"}됩니다.
              </>
            )}
          </div>
          <div className="member-decution-cnt">
            {cnt === 1000 && (
              <>
                <ul>
                  <li className="count">무제한</li>
                  {d.scheduleState === "R" && <li className="union blue">예약</li>}
                  {d.scheduleState === "E" && <li className="union green">출석</li>}
                  {d.scheduleState === "A" && <li className="union red">결석</li>}
                </ul>
                <img src={icon_right_arrow} />
                <ul>
                  <li className="count bold">무제한</li>
                  <li className="union gray">예약취소</li>
                </ul>
              </>
            )}
            {cnt !== 1000 && (
              <>
                <ul>
                  <li className="count">{pass.remainNumber}회</li>
                  {d.scheduleState === "R" && <li className="union blue">예약</li>}
                  {d.scheduleState === "E" && <li className="union green">출석</li>}
                  {d.scheduleState === "A" && <li className="union red">결석</li>}
                </ul>
                <img src={icon_right_arrow} />
                <ul>
                  <li className="count bold">{pass.remainNumber + cnt}회</li>
                  <li className="union gray">예약취소</li>
                </ul>
              </>
            )}
          </div>
          <div className="member-decution-btn-wrap">
            <div className="btn cancle" onClick={handleClose}>
              취소
            </div>
            <div className="btn rsrv-cancle" onClick={handleClickCancel}>
              예약취소
            </div>
          </div>
        </div>
      </Drawer>
    </>
  );
};

type RsrvCancleConfirm = {
  memberList: any;
  update: Function;
  PartnerClassScheduleVO: any;
  setResultMemberList: any;
};

export const RsrvCancleConfirm = ({
  memberList,
  update,
  PartnerClassScheduleVO,
  setResultMemberList,
}: RsrvCancleConfirm) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const { state: homeState } = useContext(HomeStateContext);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "RSRV_CANCLE_CONFIRM_POP",
      open: { rsrvCancleConfirmMultiPop: false },
    });
  };

  const handleClickCancel = () => {
    dispatch({ type: "LOADING_START" });
    const seqMembers = memberList.map((v: any) => v.seqMember);
    callApi(
      "/class/reservation/state",
      {
        memberList: seqMembers,
        seqPartnerClassSchedule: PartnerClassScheduleVO.seqPartnerClassSchedule,
        scheduleState: "C",
        seqPartnerCoach: PartnerClassScheduleVO.seqPartnerCoach,
      },
      "PATCH"
    )
      .then((res) => {
        if (res.msgVO) {
          if (res.msgVO.msgCd === "CMAP2030-00") {
            handleClose();
            update();
            homeState.scheduleDtlPop.update();
            setResultMemberList(res.resultMemberList);
            dispatch({
              type: "POP_UP_OPEN",
              id: "CLASS_RSRV_RESULT_POP",
              open: { classRsrvResultPop: true },
            });
            dispatch({ type: "UPDATE_SCHDULE" });
          } else {
            dispatch({ type: "UPDATE", data: { toast: true, toastText: res.MsgVO.msgCtnt } });
          }
        }
      })
      .finally(() => {
        dispatch({ type: "LOADING_END" });
      });
  };

  return (
    <>
      <Drawer
        anchor="bottom"
        open={state.rsrvCancleConfirmMultiPop}
        onClose={handleClose}
        className="picker-pop"
      >
        <div className="schedule-btn-pop">
          <div className="schedule-class-member-wrap">
            {memberList.map((v: any, i: number) => {
              if (i > 4) {
                return <></>;
              }
              return (
                <div className="schedule-class-member" key={v.seqMember}>
                  <img src={v.imgUrl || empty} />
                </div>
              );
            })}
            {memberList.length > 5 && <div className="union">+{memberList.length - 5}</div>}
          </div>
          <div className="member-name">
            {memberList.length}명의 회원님을
            <br />
            <span className="gray">일괄 예약취소 </span> 할까요?
          </div>
          <div className="member-decution">
            그룹수업 회원목록에서 회원님이 <span className="bold">삭제됩니다.</span>
          </div>
          <div className="member-decution-btn-wrap">
            <div className="btn cancle" onClick={handleClose}>
              취소
            </div>
            <div className="btn rsrv-cancle" onClick={handleClickCancel}>
              예약취소
            </div>
          </div>
        </div>
      </Drawer>
    </>
  );
};

export const ClassRsrvCancleResult = ({
  memberListCnt,
  ResultMemberList,
  setClickedMembers,
}: ScheduleClassResultProp) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CLASS_RSRV_RESULT_POP",
      open: { classRsrvResultPop: false },
    });
    dispatch({
      type: "POP_UP_OPEN",
      id: "CLASS_SCHEDULE_BTN_POP",
      open: { classScheduleBtnPop: false },
    });
    setClickedMembers([]);
  };

  let size = 0;
  for (let i = 0; i < ResultMemberList.length; i++) {
    if (ResultMemberList[i].afterScheduleState === "C") {
      size++;
    }
  }

  const list = ResultMemberList.map((d: any, i: number) => {
    const src = isEmpty(d.imgUrl) ? empty : d.imgUrl;
    let beforeClassName = "";
    if (d.beforeScheduleState === "E") {
      beforeClassName = "state green";
    } else if (d.beforeScheduleState === "R") {
      beforeClassName = "state blue";
    } else if (d.beforeScheduleState === "C") {
      beforeClassName = "state gray";
    } else if (d.beforeScheduleState === "A") {
      beforeClassName = "state red";
    } else if (d.beforeScheduleState === "W") {
      beforeClassName = "state blue";
    }

    let afterClassName = "";
    if (d.afterScheduleState === "E") {
      afterClassName = "state green bold";
    } else if (d.afterScheduleState === "R") {
      afterClassName = "state blue";
    } else if (d.afterScheduleState === "C") {
      afterClassName = "state gray";
    } else if (d.afterScheduleState === "A") {
      afterClassName = "state red";
    } else if (d.afterScheduleState === "W") {
      afterClassName = "state blue";
    }

    return (
      <div key={i} className={"schedule-class-result" + (d.psblMemberYn !== "Y" ? " disable" : "")}>
        <div className="profile-wrap">
          <img className="profile" src={src} />
          <span className="name">{d.name}</span>
        </div>
        <div className="count">
          <span className="beforeCount">
            {d.beforeUseNumber === -1 ? `무제한 ` : `${d.beforeUseNumber}회 `}
          </span>
          <span className={beforeClassName}>{scheduleState(d.beforeScheduleState)}</span>
          <img className="arrow" src={icon_to_right_small} />
          <span className="afterCount">
            {d.afterUseNumber === -1 ? `무제한 ` : `${d.afterUseNumber}회 `}
          </span>
          <span className={afterClassName}>{scheduleState(d.afterScheduleState)}</span>
        </div>
      </div>
    );
  });

  return (
    <Drawer
      anchor="bottom"
      open={state.classRsrvResultPop}
      onClose={handleClose}
      className="picker-pop"
    >
      <div className="schedule-class-result-pop">
        <div className="schedule-class-result-title">
          선택한 {memberListCnt}명중 <span className="gray">{size}명</span>의 회원님을 <br />
          <span className="gray">일괄 예약취소</span> 했어요.
        </div>
        <div className="schedule-class-result-decs">
          예약한 이용권의 잔여횟수 변경사항을 확인하세요.
        </div>
        <div className="schedule-class-result-list">{list}</div>
        <div className="schedule-class-result-btn" onClick={handleClose}>
          확인
        </div>
      </div>
    </Drawer>
  );
};

export default ShceduleClassStep;
